var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89648 7.18722H2.91732C2.45732 7.18722 2.08398 7.56055 2.08398 8.02055V11.9789C2.08398 12.4389 2.45732 12.8122 2.91732 12.8122H4.89648L8.21232 15.6214C8.75398 16.0806 9.58398 15.6956 9.58398 14.9856V5.01389C9.58398 4.30389 8.75315 3.91889 8.21232 4.37805L4.89648 7.18722Z",
    fill: "#FAFAFA",
    stroke: "#FAFAFA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9473 13.3151C13.9156 12.7134 14.5831 11.4617 14.5831 10.0042C14.5831 8.54673 13.9156 7.29423 12.9473 6.68506",
    stroke: "#FAFAFA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4202 15.8874C16.9268 14.5916 17.916 12.4416 17.916 10.0024C17.916 7.55995 16.9252 5.40828 15.416 4.11328",
    stroke: "#FAFAFA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeFull);
export default __webpack_public_path__ + "static/media/volume-full.e73fab636aeb0868bca370b339056159.svg";
export { ForwardRef as ReactComponent };